module.exports = __webpack_public_path__ + "img/admin.ae3c81a4.png";